export default {
  default: () => import("/home/forge/client-solarrechner.der-solarteur.com/layouts/default.vue").then(m => m.default || m)
}